import { useContext, useEffect, useState } from 'react';
import { Link, useParams, useSearchParams } from 'react-router-dom';
import { AuthContext } from '../auth/AuthContext';
import { communityApi as defaultApi } from './community-api';
import { PostCard } from './PostCard';
import './community.css';

export function PostDetailPage({ api = defaultApi }) {
  const auth = useContext(AuthContext);
  const { postId } = useParams();
  const [searchParams] = useSearchParams();
  const commentId = searchParams.get('comentario');
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [commentUnavailable, setCommentUnavailable] = useState(false);

  useEffect(() => {
    let cancelled = false;
    async function load() {
      setLoading(true);
      setError('');
      setCommentUnavailable(false);
      setPost(null);
      try {
        const result = await api.getPost(postId);
        if (cancelled) return;
        setPost(result);
        let comments = result.recentComments || result.comments || [];
        let cursor = result.nextCommentsCursor;
        if (commentId && !comments.some(comment => comment.id === commentId)) {
          while (cursor) {
            const page = await api.comments(postId, cursor);
            if (cancelled) return;
            comments = [...comments, ...page.comments];
            cursor = page.nextCursor;
            if (comments.some(comment => comment.id === commentId)) break;
          }
          if (cancelled) return;
          setPost({ ...result, comments, nextCommentsCursor: cursor });
          if (!comments.some(comment => comment.id === commentId)) setCommentUnavailable(true);
        }
      } catch (caught) {
        if (!cancelled) setError(caught.message || 'No se pudo cargar la publicación.');
      } finally {
        if (!cancelled) setLoading(false);
      }
    }
    load();
    return () => { cancelled = true; };
  }, [api, commentId, postId]);

  useEffect(() => {
    if (!loading && commentId) {
      const highlighted = document.querySelector('.community-post__comment--highlighted');
      if (highlighted && typeof highlighted.scrollIntoView === 'function') highlighted.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, [commentId, loading, post]);

  return <section className="gym-page community-page" aria-labelledby="community-post-detail-title">
    <Link className="gym-button gym-button--secondary" to="/comunidad">Volver a Comunidad</Link>
    <h1 id="community-post-detail-title" className="gym-page__title">Publicación</h1>
    {loading && <p className="gym-state gym-state--loading" role="status">Cargando publicación…</p>}
    {error && <p className="gym-state gym-state--error" role="alert">{error}</p>}
    {commentUnavailable && <p className="gym-state" role="status">Este comentario ya no está disponible.</p>}
    {!loading && post && <PostCard post={post} api={api} viewer={auth?.user} highlightCommentId={commentId || undefined} />}
  </section>;
}
